import { ISubcategoryContext, IFilterValues } from './subcategoryContext';

export enum SubcategoryActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_SUBCATEGORIES_BY_CUSTOMER = 'SET_SUBCATEGORIES_BY_CUSTOMER',
	SET_SUBCATEGORIES_BY_RESTAURANT = 'SET_SUBCATEGORIES_BY_RESTAURANT',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	TOGGLE_REMEMBER_MY_CHOICE = 'TOGGLE_REMEMBER_MY_CHOICE',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_ID_RESTAURANT = 'SET_ID_RESTAURANT',
	SET_ID_CATEGORY = 'SET_ID_CATEGORY',
	TOGGLE_IS_HIDDEN = 'TOGGLE_IS_HIDDEN',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_ID_FOR_DELETION = 'SET_ID_FOR_DELETION',
	SET_ID_FOR_ASSIGN_RESTAURANTS = 'SET_ID_FOR_ASSIGN_RESTAURANTS',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_FILTERS_FROM_QUERY_STRING = 'SET_FILTERS_FROM_QUERY_STRING',
}

interface IRefetchData {
	type: SubcategoryActionTypes.REFETCH_DATA;
	payload: {
		needRefetchData: ISubcategoryContext['needRefetchData'];
	};
}

interface ISetSubcategoriesByCustomer {
	type: SubcategoryActionTypes.SET_SUBCATEGORIES_BY_CUSTOMER;
	payload: {
		subcategoriesByCustomer: ISubcategoryContext['subcategoriesByCustomer'];
		typeOfModalWindow: ISubcategoryContext['typeOfModalWindow'];
	};
}

interface ISetSubcategoriesByRestaurant {
	type: SubcategoryActionTypes.SET_SUBCATEGORIES_BY_RESTAURANT;
	payload: {
		subcategoriesByRestaurant: ISubcategoryContext['subcategoriesByRestaurant'];
		typeOfModalWindow: ISubcategoryContext['typeOfModalWindow'];
	};
}

interface IChangeSearchString {
	type: SubcategoryActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: ISubcategoryContext['searchString'];
	};
}

interface IToggleRememberMyChoice {
	type: SubcategoryActionTypes.TOGGLE_REMEMBER_MY_CHOICE;
	payload: {
		rememberMyChoice: ISubcategoryContext['rememberMyChoice'];
	};
}

interface ISetIDCustomer {
	type: SubcategoryActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: ISubcategoryContext['IDSelectedCustomer'];
		subcategoriesByCustomer: ISubcategoryContext['subcategoriesByCustomer'];
		subcategoriesByRestaurant: ISubcategoryContext['subcategoriesByRestaurant'];
	};
}

interface ISetIDRestaurant {
	type: SubcategoryActionTypes.SET_ID_RESTAURANT;
	payload: {
		IDSelectedRestaurant: ISubcategoryContext['IDSelectedRestaurant'];
		isHidden: ISubcategoryContext['isHidden'];
	};
}

interface ISetIDCategory {
	type: SubcategoryActionTypes.SET_ID_CATEGORY;
	payload: {
		IDSelectedCategory: ISubcategoryContext['IDSelectedCategory'];
	};
}

interface IToggleIsHidden {
	type: SubcategoryActionTypes.TOGGLE_IS_HIDDEN;
}

interface IResetSelectedControls {
	type: SubcategoryActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetSortBy {
	type: SubcategoryActionTypes.SET_SORT_BY;
	payload: {
		sortBy: ISubcategoryContext['sortBy'];
	};
}

interface ISetCountOfItems {
	type: SubcategoryActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: ISubcategoryContext['countOfItems'];
	};
}

interface IChangeCurrentPage {
	type: SubcategoryActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: ISubcategoryContext['currentPage'];
	};
}

interface ISetIDForDeletion {
	type: SubcategoryActionTypes.SET_ID_FOR_DELETION;
	payload: {
		IDForDeletion: ISubcategoryContext['IDForDeletion'];
		typeOfModalWindow: ISubcategoryContext['typeOfModalWindow'];
	};
}

interface ISetIDForAssignRestaurant {
	type: SubcategoryActionTypes.SET_ID_FOR_ASSIGN_RESTAURANTS;
	payload: {
		IDForAssignRestaurants: ISubcategoryContext['IDForDeletion'];
		typeOfModalWindow: ISubcategoryContext['typeOfModalWindow'];
	};
}

interface IChangeTypeOfModalWindow {
	type: SubcategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: ISubcategoryContext['typeOfModalWindow'];
	};
}

interface ISetFiltersFromQueryString {
	type: SubcategoryActionTypes.SET_FILTERS_FROM_QUERY_STRING;
	payload: {
		filters: IFilterValues;
	};
}

export type TSubcategoryAction =
	| IRefetchData
	| ISetSubcategoriesByCustomer
	| ISetSubcategoriesByRestaurant
	| IChangeSearchString
	| IToggleRememberMyChoice
	| ISetIDCustomer
	| ISetIDRestaurant
	| ISetIDCategory
	| IToggleIsHidden
	| IResetSelectedControls
	| ISetSortBy
	| ISetCountOfItems
	| IChangeCurrentPage
	| ISetIDForDeletion
	| ISetIDForAssignRestaurant
	| IChangeTypeOfModalWindow
	| ISetFiltersFromQueryString;
